import { Button } from '@/components/ui/button';
import {
  Phone, Plus, UserPlus, Upload, ListTodo, MessageSquare, Zap
} from 'lucide-react';

export default function QuickActionsBar({ onNewTask, onNewLead, onNavigate, showLeads = true }) {
  const actions = [
    { id: 'task', label: 'New Task', icon: Plus, color: 'bg-[#4A3B32] hover:bg-[#3A2E26] text-white', onClick: onNewTask },
    ...(showLeads ? [{ id: 'lead', label: 'New Lead', icon: UserPlus, color: 'bg-emerald-600 hover:bg-emerald-700 text-white', onClick: onNewLead }] : []),
    { id: 'templates', label: 'Templates', icon: ListTodo, color: 'bg-white hover:bg-[#F5F3F0] text-[#4A3B32] border border-[#E6E0D9]', onClick: () => onNavigate?.('templates') },
    { id: 'automation', label: 'Automation', icon: Zap, color: 'bg-white hover:bg-[#F5F3F0] text-[#4A3B32] border border-[#E6E0D9]', onClick: () => onNavigate?.('automation') },
  ];

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="quick-actions-bar">
      {actions.map(action => {
        const IconComp = action.icon;
        return (
          <Button
            key={action.id}
            className={`h-9 text-sm px-4 ${action.color}`}
            onClick={action.onClick}
            data-testid={`quick-action-${action.id}`}
          >
            <IconComp className="w-4 h-4 mr-1.5" />
            {action.label}
          </Button>
        );
      })}
    </div>
  );
}
